const slidersStore = {
  namespaced: true,
  state: () => ({
    me: 'sliders',
    sandBox: null,
    slidersLists: {}
  }),
  getters: {
    me: state => state.me,
    //slidersLists: state => state.slidersLists
  },
  mutations: {
    setSandBox(state, data){
      state.sandBox = data
    },

    setSlideList(state, data){
      state.slidersLists[data.sliderId] = data.slideList
    }
    
  },
  actions: {
    sayHi(){
      appLog.log('HIIIIII sliders')
    },

    getSlideList({commit, getters}, sliderId) {
      // $filter=RowKey eq 'your-row-key'    RowKey eq '${sliderId}'
      // RowKey%20eq%20%27your-row-key%27    RowKey%20eq%20%27${sliderId}%27
      let sasUrl = `https://ackuretta.table.core.windows.net/web0Sliders?sv=2019-02-02&se=2025-10-29T06%3A53%3A00Z&sp=r&sig=Vp1ohn8AWTQ%2Bx80pVhf7Bz8IHpqnz5C0O%2B41x%2F29Grs%3D&tn=web0Sliders&$filter=PartitionKey%20eq%20%27${sliderId}%27`
      
      return fetch(sasUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          let dt = {
            sliderId,
            slideList: data.value
          }
          commit('setSlideList', dt)
          appLog.log('getters.slidersLists[sliderId]')
          appLog.log(getters.slidersLists[sliderId])
        })
        .catch(error => appLog.error(error))
    }
    
  }

}

vStore.registerModule('sliders', slidersStore)